import { MenuItem } from '../menu/menu-item';

/**
 * @deprecated use Menu.Item class instead: import { MenuItem } from 'main.popup'
 */
export class PopupMenuItem extends MenuItem
{
	// No additional functionality, just for compatibility
}
